import { Link, Outlet, useLocation } from "react-router-dom";
import Footer from "./common/Footer/Footer";
import "./Layout.css";
import '../index.css'
import './traningModule/traningStyle.css'
import { AdminHeader } from "./common/Header/AdminHeader";
import { AreaDirectorHeader } from "./common/Header/AreaDirectorHeader";
import { ManagerHeader } from "./common/Header/ManagerHeader";
import { OwnerHeader } from "./common/Header/OwnerHeader";
import { FryCookHeader } from "./common/Header/FryCookHeader";
import { useEffect } from "react";
import store from "../store";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserCount } from "./globalBackendReducer";
import { requestSequencer } from "../helper/helperFunctions";


const Layout = () => {
  console.log("layout console");

  const userType = useSelector((state) => state.loginUserKey.userInfo.type);

  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Location layout changed", location, location.pathname);
  }, [location]);
  // const param=user
  if (
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/forget-password" ||
    location.pathname === "/signup"
  ) {
    document.body.className += " noPadding";
  } else {
    document.body.className += " Padding";
  }

  useEffect(() => {
    /////////////////////// Sequence Endpoint Call //////////////////////////////////
    requestSequencer({ dispatch: store.dispatch, func: fetchUserCount, args: {} })
    // dispatch(fetchUserCount());
  }, []);

  return (
    <>

      <div className="mainContent p30TB">

        {/* {(location.pathname === '/admin-dashboard' || location.pathname === '/trainings/lessons' || location.pathname === '/admin-dashboard/add-edit-admin' || location.pathname === '/admin-dashboard/add-edit-owner' || location.pathname === '/area_director-dashboard/area-directors/list' || location.pathname === '/area_director-dashboard/area-directors/add' || location.pathname === '/area-directors/list' || location.pathname === '/trainings/training/add' || location.pathname === '/trainings/training' || location.pathname === '/trainings/training/add-edit-training-catagory' || location.pathname === '/trainings/lessons/add' || location.pathname === '/admin-dashboard/add-edit-manager' || location.pathname === '/product/list' || location.pathname === '/users' || location.pathname === '/add-edit-traning' || location.pathname === '/list-training' || location.pathname === '/list-lessons' || location.pathname === '/list-shop' || location.pathname.includes("trainingcenter") || (location.pathname.includes("vat-list") && (store.getState().loginUserKey.userInfo.type == "admin"))) &&
          <AdminHeader />
        } */}
        {userType === "admin" && location.pathname !== "/login" && (
          <AdminHeader />
        )}
        {/* {location.pathname === '/area-director-dashboard' &&
          <AreaDirectorHeader />
        } */}
        {userType === "area_director" && location.pathname !== "/login" && (
          <AreaDirectorHeader />
        )}
        {/* {(location.pathname === '/manager-dashboard' || (location.pathname.includes("vat-list") && (store.getState().loginUserKey.userInfo.type == "manager"))) &&
          <ManagerHeader />
        } */}
        {userType === "manager" && location.pathname !== "/login" && (
          <ManagerHeader />
        )}
        {/* {(location.pathname === '/owner-dashboard' || location.pathname.includes('/general-link')) &&
          <OwnerHeader />
        } */}
        {userType === "owner" && location.pathname !== "/login" && (
          <OwnerHeader />
        )}
        {/* {(location.pathname === '/frycook-dashboard') &&
          <FryCookHeader />
        } */}
        {userType === "frycook" && location.pathname !== "/login" && (
          <FryCookHeader />
        )}

        {/* {location.pathname === '/add-edit-traning' &&
          <AddeditTraning />
        } */}
        {/* {location.pathname === '/listing-training-catagory' &&
          <Listingtrainingcatagory />
        } */}
        {/* <Header /> */}
        <div className="pageMain">
          <Outlet />
        </div>

        {((location.pathname !== "/" &&
          location.pathname !== "/forget-password" &&
          location.pathname === "/admin-dashboard") ||
          location.pathname === "/trainings/lessons" ||
          location.pathname === "/admin-dashboard/add-edit-admin" ||
          location.pathname === "/trainings/training" ||
          location.pathname ===
          "/trainings/training/add-edit-training-catagory" ||
          location.pathname === "/admin-dashboard/add-edit-owner" ||
          location.pathname === "/admin-dashboard/add-edit-area-director" ||
          location.pathname === "/admin-dashboard/add-edit-manager" ||
          location.pathname === "/product/list" ||
          location.pathname === "/list-training" ||
          location.pathname === "/brand-list" ||
          location.pathname === "/list-lessons" ||
          location.pathname.includes("trainingcenter") ||
          location.pathname === "/owner-dashboard" ||
          location.pathname === "/users" ||
          location.pathname.includes("/general-link") ||
          location.pathname.includes("/tpm")) && <Footer />}
      </div>
    </>
  );
};

export default Layout;
